import { createFileRoute } from '@tanstack/react-router';

import { EditorPage } from '@/features/editor/EditorPage';

/**
 * Editor route for a specific plan. Loads the plan and its first floor and
 * renders the Konva canvas with pan/zoom + fit-to-floor controls. Item
 * placement, rooms, fixtures, multi-floor switching, and versioning land in
 * later phase-1 tasks but plug into this same route.
 */
export const Route = createFileRoute('/_app/plans/$planId')({
  component: EditorRouteComponent,
});

function EditorRouteComponent() {
  const { planId } = Route.useParams();
  return <EditorPage planId={planId} />;
}
